<div class="UNFAPP-success-animtd-icon-area">
    <img src="assets/img/Frame2.png" class="UNFAPP-success-animtd-icn" />
</div>

<h3 class="UNFAPP-loginvia-hdng text-center">{{data?.message1}}</h3>
<h5 class="UNFAPP-loginvia-subhdng text-center">{{data?.message2}}</h5>
<div class="UNFAPP-logwthpass text-center">
    <button type="button" class="UNFAPP-blue-txt-link" (click)="close()">CLOSE</button>
</div>
